import canvasScratchCard from 'canvas-scratch-card';
import React, { useMemo, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { cx } from 'react-twc';
import { useIsomorphicLayoutEffect } from 'usehooks-ts';

import { useSeenTickets } from '@/features/Fortune/useFortune';

const FortuneCanvas = ({ src, fortuneId }: { src: string; fortuneId: string }) => {
  const [seenTickets, setSeenTickets] = useSeenTickets();

  const ref = useRef(null);

  const reveal = () => {
    if (!seenTickets.includes(fortuneId)) {
      setSeenTickets([...seenTickets, fortuneId]);
    }
  };

  useIsomorphicLayoutEffect(() => {
    if (!ref.current) return;
    canvasScratchCard.init({
      dom: ref.current,
      r: 40,
      rate: 0.4,
      image: '/img/fortune/result/fortune-cover.png',
      callback: () => {
        if (!seenTickets.includes(fortuneId)) {
          setSeenTickets([...seenTickets, fortuneId]);
        }
        canvasScratchCard.reset();
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isRevealed = useMemo(() => {
    return seenTickets.includes(fortuneId);
  }, [seenTickets, fortuneId]);

  return (
    <div className="w-full h-full relative overflow-hidden">
      {isRevealed && <img src={src} alt="이미지" className="w-full h-full" />}

      {!isRevealed && (
        <div
          ref={ref}
          style={{
            width: '302px',
            height: '143px',
            margin: '0 auto',
            zIndex: 10,
            background: `url(${src}) no-repeat center center`,
            backgroundSize: 'contain',
            cursor: `url(data:image/svg+xml;base64,${btoa(`
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="20" fill="#FCCDAB"/>
              </svg>
              `)}) 20 20, auto`,
          }}
          data-gtm-id="fortune-result-lottery-scratch"
        />
      )}
      {isMobile && (
        <div
          className={cx(
            'absolute top-0 left-0 text-center w-full h-full z-30 flex justify-center items-center',
            isRevealed ? 'translate-x-full ' : 'translate-x-0',
            'duration-700 transition-all cursor-pointer',
          )}
          onClick={reveal}
          style={{
            background: `url(/img/fortune/result/fortune-cover.png)`,
            backgroundSize: '100%',
            cursor: 'pointer',
          }}
          data-gtm-id="fortune-result-lottery-click"
        />
      )}
    </div>
  );
};

export default FortuneCanvas;
